
import Dashboard from "views/Principal";
import Vazia from "views/Principal/vazia";

import Usuario from "views/Usuario/";
import Configuracao from "views/Configuracao/";

import Categorias from "views/Cadastros/Categorias";
import Clientes from "views/Cadastros/Clientes";
import Convenios from "views/Cadastros/Convenios";
import Estabelecimentos from "views/Cadastros/Estabelecimentos";
import Fornecedores from "views/Cadastros/Fornecedores";
import Lojas from "views/Cadastros/Lojas";
import PlanoContas from "views/Cadastros/PlanoContas";
import Produtos from "views/Cadastros/Produtos";
import Premios from "views/Cadastros/Premios";
import Subcategorias from "views/Cadastros/Subcategorias";
import Substancias from "views/Cadastros/Substancias";
import Usuarios from "views/Cadastros/Usuarios";
import Vendedores from "views/Cadastros/Vendedores";
import Perfis from "views/Cadastros/Perfis";
import Favorecidos from "views/Cadastros/favorecido";

import CartaoFidelidade from "views/Fidelidade/CartaoFidelidade";
import Precificacoes from "views/Fidelidade/Precificacoes";

// import Caixas from "views/Financeiro/Caixas";
import Caixas from "views/Caixas";
import CaixasTotalizados from "views/Caixas/Totalizados";
import Vendas from "views/Vendas";

//import ConsultaVendas from "views/Gerenciamento/ConsultaVendas";
import EntradaNFe from "views/NFe/EntradaNFe";
import StatusNFe from "views/NFe/StatusNFe";
import BuscarNFe from "views/NFe/BuscarNFe";
import ConfigNFe from "views/NFe/ConfigNFe";
import Relatorios from "views/Relatorios";
// import Tabloide from "views/Tabloide/";

import AtendimentosDiarios from "views/Graficos/AtendimentosDiarios";
import VendasDiarias from "views/Graficos/VendasDiarias";
import GraficoEstatistica from "views/Graficos/estatistica";

import ContasApagar from "views/Contas/ContasApagar";
import FechaConvenio from "views/Contas/FechaConvenio";

import Kit from "views/Campanhas/Kit/";
import Tabloide2 from "views/Campanhas/Tabloide/";
import Campanha from "views/Campanhas/Campanha/";
import ProdutosCampanha from "views/Campanhas/Campanha/ProdutosCampanha";

import Lucro from "views/Estatistica/Lucro/";
import CurvaABC from "views/Estatistica/CurvaABC/";
import CurvaABCD from "views/Estatistica/CurvaABCD/";
import Atendimento from "views/Estatistica/Atendimento/";
import Desconto from "views/Estatistica/Desconto/";
import EstatisticaVendas from "views/Estatistica/Vendas/";
import EstatisticaProjecao from "views/Estatistica/Projecao/";
import EstatisticaDelivery from "views/Estatistica/Delivery/";
import PrecosEcommerce from "views/Precos/Ecommerce/PrecosEcommerce";

import AssistentePedidos from "views/Pedidos/Assistente/Index";

const rotasMapeamento = {
  Dashboard,
  Vazia,
  Usuario,
  Configuracao,
  Categorias,
  Clientes,
  Convenios,
  Estabelecimentos,
  Fornecedores,
  Lojas,
  PlanoContas,
  Produtos,
  Premios,
  Subcategorias,
  Substancias,
  Usuarios,
  Vendedores,
  Perfis,
  Favorecidos,
  CartaoFidelidade,
  Precificacoes,
  Caixas,
  CaixasTotalizados,
  Vendas,
  EntradaNFe,
  StatusNFe,
  BuscarNFe,
  ConfigNFe,
  Relatorios,
  // Tabloide,
  AtendimentosDiarios,
  VendasDiarias,
  GraficoEstatistica,
  ContasApagar,
  FechaConvenio,
  Kit,
  Tabloide2,
  Campanha,
  ProdutosCampanha,
  Lucro,
  CurvaABC,
  CurvaABCD,
  Atendimento,
  Desconto,
  EstatisticaVendas,
  EstatisticaProjecao,
  EstatisticaDelivery,
  PrecosEcommerce,
  AssistentePedidos
}

export default rotasMapeamento;